import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    errorSubmitApplication : ''
}

const submitApplicationReducer =(state = initialState,action)=>{
    switch(action.type.type){
            case actionTypes.SUBMIT_APPLICATION_SUCCESS:
                return updateObject(state, {
                    errorSubmitApplication :''
                })
            case actionTypes.SUBMIT_APPLICATION_FAILED:
                return updateObject(state, {
                    errorSubmitApplication:action.type.error.msg
                })
            default:{
                return state;
            }
        }
}

export default submitApplicationReducer;